<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.paciente"
        :disabled-button-search="true"
        ref="DataTable"
        sort-by="nome"
    >
    <template v-slot:cell(nome)="{ item }">
        {{ item.nome }}
        <template v-if="item.nomeSocial">
            <template v-if="item.preferenciaNomeId == enums.preferenciaNome.NOME_SOCIAL">
                <strong>({{ item.nomeSocial }})</strong>
            </template>
            <template v-else>
                ({{ item.nomeSocial }})
            </template>
        </template>
    </template>
    <template v-slot:cell(dataNascimento)="row">
        {{ row.value | formatDate }}
    </template>
    <template v-slot:cell(cpf)="row">
        {{ row.value | formatCpf }}
    </template>
    <template v-slot:cell(cns)="row">
        {{ row.value | formatCns }}
    </template>
    <template v-slot:cell(actions)="{ item }">
        <template v-if="!$scopedSlots.actions">
            <rkm-button
                @click="handleEdit(item)"
                color="primary"
                small
                title="Agendar"
                autorize="edit-transporte-paciente-pre-agendamento-transporte"
            >
                <rkm-icon icon="calendar" />
            </rkm-button>
        </template>
    </template>

    </rkm-data-table>
</template>

<script>
import { error, repository, stringCase } from '@/mixins';
import format from '@/filters/formats'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'
import subclassificacao from '@/enums/cadastro/paciente/subclassificacao'

// Vuex.
import { mapActions } from 'vuex'

export default {
    data: () => ({
        enums: {
            preferenciaNome,
            subclassificacao,
        }
    }),
    filters: {
        ...format,
    },
    computed: {
        fields() {
            return [
            {
                name: 'cadastroCidadao.nome',
                key: 'nome',
                label: 'Nome (Nome social)',
                searchable: true,
                sortable: true
            },
            {
                name: 'cadastroCidadao.nomeSocial',
                key: 'nomeSocial',
                label: 'Nome social',
                searchable: true,
                sortable: true,
                visible: false
            },
            {
                name: 'cadastroCidadao.dataNascimento',
                key: 'dataNascimento',
                label: 'Data de nascimento',
                searchable: true,
                sortable: true
            },
            {
                name: 'cadastroCidadao.nomeMae',
                key: 'nomeMae',
                label: 'Nome da mãe',
                searchable: true,
                sortable: true
            },
            {
                name: 'cadastroPaciente.prontuario',
                key: 'prontuario',
                label: 'Prontuário municipal',
                searchable: true,
                sortable: true
            },
            {
                name: 'cadastroCidadao.cpf',
                key: 'cpf',
                label: 'CPF',
                searchable: true,
                sortable: true
            },
            {
                name: 'cadastroCidadao.cns',
                key: 'cns',
                label: 'CNS',
                searchable: true,
                sortable: true
            },
            {
                name: 'actions',
                key: 'actions',
                label: 'Ações',
                class: 'col-min'
            },
        ]
        }
    },
    created() {
        this.repositories = {
            preAgendaTransporte: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
        }
    },
    methods: {
        ...mapActions([ 'setLoading', 'unsetLoading' ]),
        handleEdit(item) {

            this.setLoading()

            this.repositories.paciente.validCNS(this.camelObjectKeysToSnakeRecursive({pacienteId: item.id}))
                .then(response => {

                    if (!response.data.additionals.cnsValido && response.data.additionals.avisaCnsTemporarioInvalido) {

                        this.showWarningNotification('Paciente com CNS inválido. Registro não permitido.')
                        return false
                    }

                    if (item.subclassificacaoId === this.enums.subclassificacao.TEMPORARIO
                        && response.data.additionals.avisaCnsTemporarioInvalido) {

                            const confirm = async () => {

                                this.$nextTick().then(() => this.irParaPreAgendamento(item))

                                return false
                            }

                            const msg = `Paciente com cadastro temporário. Deseja continuar?`

                            this.showConfirmation(msg, confirm)

                            return false
                    }

                    if (item.diasCadastroDesatualizado > 0) {

                        const confirm = async () => {

                            this.$nextTick().then(() => this.irParaPreAgendamento(item))

                            return false
                        }

                        let msg = `Paciente com cadastro desatualizado há <strong>${item.diasCadastroDesatualizado}</strong>
                            dia(s). Deseja continuar?`

                        if (item.enderecoDesatualizadoBloqueado) {

                            msg = `Paciente com cadastro desatualizado há <strong>${item.diasCadastroDesatualizado}</strong>
                                dia(s). Endereço do usuário também deve ser atualizado. Deseja continuar?`
                        }

                        this.showConfirmation(msg, confirm)

                        return false
                    }

                    this.irParaPreAgendamento(item)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        irParaPreAgendamento(item) {

            if (item.enderecoDesatualizadoBloqueado) {

                this.showAlert(
                    'O endereço do paciente ainda não foi atualizado pela Base Nacional. Atualize o cadastro para continuar.',
                    'Atenção'
                )

                return
            }

            this.$router.push({ name: 'pre-agendamento-transporte-edit', params: { id: item.id } })
        },
    },
    mixins: [ error, repository, stringCase ],
}
</script>